import { createFileRoute, Link } from "@tanstack/react-router";

/**
 * Public profile placeholder — fleshed out alongside the /me settings flow.
 * Phase 8 needs this route to exist for the bottom tab bar's "Me" link.
 */
export const Route = createFileRoute("/user/$id")({
  component: UserProfile,
});

function UserProfile() {
  const { id } = Route.useParams();
  return (
    <main className="mx-auto w-full max-w-2xl px-4 sm:px-5 py-6 sm:py-8 flex-1">
      <p className="text-xs text-[color:var(--color-fg-muted)] mb-2">
        <Link to="/" className="hover:underline">← back</Link>
      </p>
      <h1 className="text-2xl font-semibold tracking-tight mb-2">Profile</h1>
      <p className="text-sm text-[color:var(--color-fg-muted)]">User id: {id}</p>
      <p className="mt-4 text-sm text-[color:var(--color-fg-muted)]">
        Public-profile content is rolled out alongside the /me settings flow.
      </p>
    </main>
  );
}
